export const currencies = ['AUD', 'BRL', 'CAD', 'CHF', 'CNH', 'EUR', 'GBP', 'HKD', 'SGD', 'JPY', 'NZD', 'USD'].sort()

export const licenses = [
  'AUTO_QUOTE',
  'BUY_BOND_RFQ',
  'DASHBOARD',
  'DISTRIBUTED_LEDGER',
  'GTREASURY_ATV_STP',
  'ICAP_ATV_STP',
  'ISSUER_TRADES',
  'PORTFOLIO',
  'REPORTING_PORTFOLIO_PERFORMANCE',
  'REPORTING_PORTFOLIO',
  'RFQ_REPORTING_CSV',
  'RFQ_REPORTING',
  'SANDBOX',
  'UNSOLICITED_RATESHEET',
  'UNSOLICITED_RATESHEET_REPORTING',
  'MARKET_INSIGHTS',
]
